((app, ng) => {

    app.config($stateProvider => {
        $stateProvider.state("Home.Dashboard",
            {
                url: "/Dashboard",
                component: "dashboard",
                data: {
                    pageTitle: "Dashboard"
                }
            });
    });

    app.component("dashboard",
        {
            templateUrl: "/App/Dashboard/dashboard.template.html",
            controller: dashboardController,
            bindings: {
                currentUser: "<"
            }
        });

    function dashboardController(dashboardApi, moment, userApi, $location) {
        const $ctrl = this;
        $ctrl.parentToDos = $location.search().parentToDos;

        ng.extend($ctrl,
            {
                // default tile selection. We'll use track by in HTML template to prevent dupe issue with ngrepeat
                dashboardTiles: [],
                defaultTiles: [],
                today: moment().format()
            });

        // set the user's active tile based on the current active tile & the selected option
        // see HTMl template ng-init to see how the parent tile index is captured
        $ctrl.setActiveTile = (activeTileIndex, selectedOption) => {
            $ctrl.dashboardTiles[activeTileIndex] = selectedOption;
            setUsersDashboardTiles($ctrl.currentUser.Id, $ctrl.dashboardTiles);
        };

        //const getDefaultDashboardTiles = () => {
        //    return dashboardApi.getDefaultDashboardTiles();
        //};

        //const getUsersDashboardTiles = userId => {
        //    return userApi.getUsersDashboardTiles(userId);
        //};

        const setUsersDashboardTiles = (userId, dashboardTiles) => {
            let tileEnums = convertToEnumList(dashboardTiles);
            return userApi.setUsersDashboardTiles(userId, tileEnums);
        };

        // we're converting the enum list to a key/value list to better display on the UI
        const convertToDashboardTiles = enumList => {
            let result = [];

            enumList.forEach((tileEnum) => {
                let tileObj = {
                    enum: tileEnum,
                    //searchText: "",
                    //isSearchHidden: true,
                    displayName: tileEnum.replace(/([A-Z])/g, ' $1')
                };

                result.push(tileObj);
            });

            return result;
        };

        // we need to convert the key/value list back to the enum list to send to the backend
        const convertToEnumList = dashboardTiles => {
            let result = [];

            dashboardTiles.forEach(tile => {
                result.push(tile.enum);
            });

            return result;
        };

        // in case the endpoint fails to return the default options
        const fallbackDefaultEnums = ["Todos", "Reports", "Balances", "QuickLinks", "PendingBusiness", "LatestInforceInsurance", "UpcomingBirthdays"];
        const fallbackDefaultTiles = convertToDashboardTiles(fallbackDefaultEnums);

        $ctrl.$onInit = () => {
            dashboardApi.getDefaultDashboardTiles()
                .then(response => {
                    if (response) $ctrl.defaultTiles = convertToDashboardTiles(response);
                    else $ctrl.defaultTiles = fallbackDefaultTiles;

                })
                .catch(error => {
                    $ctrl.defaultTiles = fallbackDefaultTiles;
                    console.log(error);
                });

            userApi.getUsersDashboardTiles($ctrl.currentUser.Id)
                .then(response => {
                    if (response.DashboardTiles && response.DashboardTiles.length) $ctrl.dashboardTiles = convertToDashboardTiles(response.DashboardTiles);
                    else $ctrl.dashboardTiles = fallbackDefaultTiles;
                })
                .catch(error => {
                    $ctrl.dashboardTiles = fallbackDefaultTiles;
                    console.log(error);
                });
        };
    }

})(window.app, window.angular);